import styled, { css } from 'styled-components';
import { Wrapper } from 'AppReact';

const Div = styled.div`
  ${({ displayState }) => css`
    opacity: ${displayState?.opacity ?? 1};
  `}
`;

export default Wrapper(Div);
